// extracted by mini-css-extract-plugin
export default {"blogPageWrapper":"Blog-Page_blogPageWrapper__Qnvws","blogPageContainer":"Blog-Page_blogPageContainer__lzjRc"};